// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .app-paginator {
  display: flex;
  align-items: center;
  justify-content: center;
}

.trigger {
  height: 40px;
}

.range {
  border-radius: 4px;
  display: inline-block;
  padding: 8px;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  transition: background-color 0.2s;
}

.range.enabled:hover,
.range.active {
  background-color: aliceblue;
  cursor: pointer;
}

.mat-icon-button {
  width: 36px;
  height: 36px;
  line-height: 0;
}

button:focus::before,
button:active:not(:disabled)::before {
  content: "";
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: 50%;
}

svg {
  fill: currentColor;
  width: 20px;
}

.mat-menu-item {
  font-size: 13px;
}

.mat-menu-item .mat-icon {
  color: rgba(115, 134, 213, 0.8);
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/paginator/paginator.component.scss"],"names":[],"mappings":"AAAA;EACG,aAAA;EACA,mBAAA;EACA,uBAAA;AACH;;AAEA;EACG,YAAA;AACH;;AAEA;EACG,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,iCAAA;AACH;;AAEA;;EAEG,2BAAA;EACA,eAAA;AACH;;AAEA;EACG,WAAA;EACA,YAAA;EACA,cAAA;AACH;;AAEA;;EAEG,WAAA;EACA,oDAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;AACH;;AAEA;EACG,kBAAA;EACA,WAAA;AACH;;AAEA;EACG,eAAA;AACH;;AAEA;EACG,+BAAA;EACA,iBAAA;AACH","sourcesContent":["::ng-deep .app-paginator {\n   display: flex;\n   align-items: center;\n   justify-content: center;\n}\n\n.trigger {\n   height: 40px;\n}\n\n.range {\n   border-radius: 4px;\n   display: inline-block;\n   padding: 8px;\n   user-select: none;\n   background-color: transparent;\n   transition: background-color .2s;\n}\n\n.range.enabled:hover,\n.range.active {\n   background-color: aliceblue;\n   cursor: pointer;\n}\n\n.mat-icon-button {\n   width: 36px;\n   height: 36px;\n   line-height: 0;\n}\n\nbutton:focus::before,\nbutton:active:not(:disabled)::before {\n   content: '';\n   box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .2);\n   position: absolute;\n   left: 0;\n   top: 0;\n   right: 0;\n   bottom: 0;\n   border-radius: 50%;\n}\n\nsvg {\n   fill: currentColor;\n   width: 20px;\n}\n\n.mat-menu-item {\n   font-size: 13px;\n}\n\n.mat-menu-item .mat-icon {\n   color: rgba(115, 134, 213, 0.8);\n   margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
